<template>
  <div class="central_content">
    <Button
      @click="
        upData = {};
        title = '添加';
        Show = true;
      "
      style="margin-right: 15px"
      type="primary"
      >添加</Button
    >
    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '编辑';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >编辑</Button
        >
        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >删除</Button
        >
      </template>
    </Table>
    <Modal width="500" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '删除'">删除</div>
      <div v-else style="display: flex; align-items: center; margin-top: 15px">
        <div>名称:</div>
        <div>
          <Input
            v-model="upData.name"
            placeholder="名称"
            style="width: 300px"
          />
        </div>
      </div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      userList: { list: [] },
      title: "",
      upData: {},
      Show: false,
      parameter: {
        pageNow: 1,
      },
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id",
        },
        {
          title: "名称",
          className: "fontcolor",
          align: "center",
          key: "name",
        },
        {
          title: "创建时间",
          align: "center",
          className: "fontcolor",
          key: "createTime",
        },

        {
          title: "修改时间",
          align: "center",
          key: "modifyTime",
          className: "fontcolor",
        },

        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right",
        },
      ],
    };
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    UaorderShip() {
      if (this.title == "添加") {
        api.OutsideGroupAdd(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "编辑") {
        api.OutsideGroupEdit(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "删除") {
        api.OutsideGroupDel(this.upData.id).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData() {
      api.OutsideGroupQueryList(this.parameter).then((res) => {
        this.userList = res.body.data;
      });
    },
  },
};
</script>

<style scoped>
</style>